<template>
  <default-layout>
    <div class="is-clearfix">
      <h3 class="title is-3 is-pulled-left">Users</h3>
      <router-link class="button is-primary is-pulled-right" :to="{ name: 'createAdmin' }">Create Admin</router-link>
    </div>

    <users-list></users-list>
  </default-layout>
</template>

<script>
import UsersList from '../components/users/UsersList.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    DefaultLayout,
    UsersList
  }
}
</script>
